import React from 'react';
import "./ShipmentMap.scss";
import "leaflet/dist/leaflet.css";
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
import L from "leaflet";
import { getMarkerIcons } from '../../utils/images';



const PopeyeUpdatesShipmentMap = ({ selectedShipment }) => {
  // Constants for coordinates and zoom level
  const longitude = selectedShipment?.lng ?? 0;
  const latitude = selectedShipment?.lat ?? 0;
  return (
    <div className="ShipmentMap">
      <MapContainer center={[latitude, longitude]} zoom={4} scrollWheelZoom={false} style={{ height: 'inherit' }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='Map data © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={[latitude, longitude]} icon={L.icon({
          iconUrl: getMarkerIcons('current-location'),
          iconSize: [58, 58],
          iconAnchor: [15, 15],
          popupAnchor: [-3, -10]
        })} />
      </MapContainer>
    </div>
  );

};

export default PopeyeUpdatesShipmentMap;
